import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../../api/auth";
import { DEFAULT_BRANDING } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { errorMessage } from "../../shared/errors";
import { useInvalidateMe } from "../../shared/hooks/useMe";
import { safeReturnTo } from "../../shared/returnTo";
import { Alert, Spinner } from "../../ui";

export function VerifyEmailPage() {
  const [search] = useSearchParams();
  const token = search.get("token");
  const returnTo = safeReturnTo(search.get("return_to"));
  const invalidateMe = useInvalidateMe();
  const [state, setState] = useState<"pending" | "ok" | "error">("pending");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setError("This verification link is missing its token.");
      return;
    }
    authApi
      .confirmVerification(token)
      .then(() => {
        setState("ok");
        return invalidateMe();
      })
      .catch((err) => {
        setState("error");
        setError(
          errorMessage(
            err,
            "This verification link is invalid or has expired.",
          ),
        );
      });
  }, [token, invalidateMe]);

  return (
    <AuthShell branding={DEFAULT_BRANDING} title="Verify your email">
      {state === "pending" ? <Spinner label="Verifying" /> : null}
      {state === "ok" ? (
        <div className="flex flex-col gap-4">
          <Alert kind="success">Your email address is verified.</Alert>
          {returnTo && returnTo.startsWith("/") ? (
            <Link className="text-brand underline" to={returnTo}>
              Continue
            </Link>
          ) : returnTo ? (
            <a className="text-brand underline" href={returnTo}>
              Continue
            </a>
          ) : (
            <Link className="text-brand underline" to="/account">
              Go to your account
            </Link>
          )}
        </div>
      ) : null}
      {state === "error" ? <Alert kind="error">{error}</Alert> : null}
    </AuthShell>
  );
}
